import { json2csv } from "json-2-csv";
import { parse } from "jsonlint-mod";
export function getJSONToCSV(_ref) {
  var input = _ref.input;
  var json = parse(input);
  return json2csv(json);
}